import { prop } from '../../../utils/xp.v1'

export default {
  numOfRedDot(state) {
    return (item) => {
      const o = prop(state.Cache, item, null)
      return o && o.num > 0 ? +o.num : 0
    }
  }
}
